import { Box } from '@mui/material';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import Image from 'next/image';
import React from 'react';

import { ContentBlock } from '../../layouts/ContentBlocks';

const SocialProofBrands = () => {
  const { md } = useBreakpoints();
  
  const brandLogos = [
    { name: 'Trusted By nation\'s top brokerages', logo: '/images/brands/trusted-by-logo.png', width: md ? 180 : 150, height: md ? 86 : 86 },
    { name: 'COMPASS', logo: '/images/brands/compass-logo.png', width: md ? 140 : 140, height: md ? 100 : 86 },
    { name: 'Orchard', logo: '/images/brands/orchard-logo.png', width: md ? 100 : 140, height: md ? 80 : 86 },
    { name: 'Sotheby\'s INTERNATIONAL REALTY', logo: '/images/brands/sothebys-logo.png', width: md ? 120 : 120, height: md ? 80 : 86 },
    { name: 'DouglasElliman', logo: '/images/brands/douglas-elliman-logo.png', width: md ? 200 : 180, height: md ? 100: 100 },
    { name: 'exp REALTY', logo: '/images/brands/exp-realty-logo.png', width: md ? 80 : 80, height: md ? 70 : 86 },
  ];

  return (
    <ContentBlock
      margin={[0, 'auto']}
    >
      <Box
        display={md ? 'flex' : 'grid'}
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        maxWidth={1308}
        margin="0 auto"
        sx={{
          gridTemplateColumns: '1fr 1fr',
        }}
      >
        {brandLogos.map((brand, i) => (
          <Box
            key={i}
            flex={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Image
              src={brand.logo}
              alt={brand.name}
              width={brand.width}
              height={brand.height}
              style={{
                objectFit: 'contain'
            
              }}
            />
          </Box>
        ))}
      </Box>
    </ContentBlock>
  );
};

export default SocialProofBrands;
